import { IAppState } from '../../types/redux';

export function selectLandingType(state: IAppState) {
  return state.landingType;
}
